import { Reducer } from 'redux'
import {
  FreeTrialsActionTypes,
  type FreeTrialsAction,
  type FreeTrialsState,
  type ProductDimensionFreeTrial,
  initialFreeTrialsState,
} from './types'

export * from './types'

export const reducer: Reducer<FreeTrialsState, FreeTrialsAction> = (
  state = initialFreeTrialsState,
  action
) => {
  switch (action.type) {
    case FreeTrialsActionTypes.UPDATE_FREE_TRIALS_DIMENSION_ROW_QUANTITY: {
      const { productId, index, quantity } = action.payload
      const productDimensions = state[productId].productDimensions.map(
        (dimension, i) => {
          if (i === index) {
            return {
              ...dimension,
              freeTrial: {
                enabled:
                  !isNaN(quantity) && Number(quantity) !== 0 ? true : false,
                quantity,
              },
            }
          }
          return dimension
        }
      )
      return {
        ...state,
        [productId]: {
          ...state[productId],
          productDimensions,
        },
      }
    }
    case FreeTrialsActionTypes.ADD_FREE_TRIALS_DIMENSION_ROW: {
      const productId = action.payload
      const product = state[action.payload]
      const productDimensions = [...product.productDimensions]
      productDimensions.push({} as ProductDimensionFreeTrial)
      return {
        ...state,
        [productId]: {
          ...state[productId],
          productDimensions,
        },
      }
    }
    case FreeTrialsActionTypes.REMOVE_FREE_TRIALS_DIMENSION_ROW: {
      const { productId, index } = action.payload
      const productDimensions = [...state[productId].productDimensions]
      productDimensions.splice(index, 1)
      return {
        ...state,
        [productId]: {
          ...state[productId],
          productDimensions,
        },
      }
    }
    case FreeTrialsActionTypes.UPDATE_FREE_TRIALS_DIMENSION_ROW_ID: {
      const { productId, index, id } = action.payload
      const productDimensions = state[productId].productDimensions.map(
        (dimension, i) => {
          if (i === index) {
            return {
              ...dimension,
              productDimensionId: id,
            }
          }
          return dimension
        }
      )
      return {
        ...state,
        [productId]: {
          ...state[productId],
          productDimensions,
        },
      }
    }
    case FreeTrialsActionTypes.UPDATE_FREE_TRIALS_NUMBER_OF_DAYS: {
      const { productId, numberOfDays } = action.payload
      return {
        ...state,
        [productId]: {
          ...state[productId],
          freeTrial: {
            ...state[productId].freeTrial,
            freeTrialExpiresInDays: numberOfDays,
          },
        },
      }
    }
    case FreeTrialsActionTypes.ADD_FREE_TRIALS_PRODUCT: {
      const productId = action.payload
      return {
        ...state,
        [productId]: {
          productId,
          freeTrial: {
            enabled: true,
          },
          productDimensions: [],
        },
      }
    }
    case FreeTrialsActionTypes.UPDATE_EULA_TYPE: {
      const { productId, eulaType } = action.payload
      return {
        ...state,
        [productId]: {
          ...state[productId],
          eulaType,
        },
      }
    }
    case FreeTrialsActionTypes.ADD_EULA_FILES: {
      const { productId, eulaFiles } = action.payload

      return {
        ...state,
        [productId]: {
          ...state[productId],
          eulaFile: eulaFiles,
        },
      }
    }
    case FreeTrialsActionTypes.UPDATE_ON_REVIEW: {
      const { productId, onReview } = action.payload

      return {
        ...state,
        [productId]: {
          ...state[productId],
          onReview: onReview,
        },
      }
    }
    default: {
      return state
    }
  }
}
